module.exports = __webpack_public_path__ + "static/media/menu_bars.4019a675.svg";